module.exports = __webpack_public_path__ + "static/media/icon-sales-lost-white.77dc05f2.svg";